import actions from './actions'

const defaultState = {
  reportRow: ''
}

const reportRow = (state = defaultState, action) => {
  switch (action.type) {
    case actions.set:
      return { ...state, reportRow: action.reportRow }
    default:
      return state
  }
}

export default reportRow



// WEBPACK FOOTER //
// ./src/store/report-row/reducer.js